
import { AxiosStatic } from 'axios';

import { AbstractQueryAction, ActionData, DataResult, OPERATION_ERROR_FATAL } from './data_query';
import { ServerResult } from './server_result';
import { Plugins } from '@capacitor/core'
const { Storage } = Plugins;

export class ServerQueryService {
  public dataQueries: AbstractQueryAction[];
  // token: string;

  constructor(
    private http: AxiosStatic,
    // private config: ConfigurationService
    // private auth: AuthenticationService
  ) {
    this.dataQueries = [];
  }

  public add(query: AbstractQueryAction) {
    this.dataQueries.push(query);
  }

  public packageQuery(queries: AbstractQueryAction[], options?: any): Promise<DataResult> {
    return this.execute(queries, options);
  }

  public query(): Promise<DataResult> {
    return this.execute(this.dataQueries);
  }

  public instantQuery(operations: AbstractQueryAction[], options?: any): Promise<ServerResult> {

    const query = this.packageQuery(operations, options);

    return new Promise((resolve, reject) => {
      query.then((response) => {
        const serverResult = ServerResult.fromResponse(response.data);
        if (serverResult.hasError() && serverResult.getErrorLevel() === OPERATION_ERROR_FATAL) {
          reject(serverResult);
        } else {
          resolve(serverResult);
        }
      });
    });
  }

  private execute(queries: AbstractQueryAction[], options?: any): Promise<DataResult> {
    const jsonPayload: ActionData[] = queries.reduce( (accum: ActionData[], query) => {
      console.log(query);
      accum.push(query.serialize());
      return accum;
    }, [] );

    // http://${this.config.domain}'
    return this.http.post(
      `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/batch`,
      JSON.stringify({actions: jsonPayload}),
      options
    );
  }

  // Vue.axios.defaults.headers.common['X-CSRFToken'] = (document as any).querySelector('meta[name="csrf-token"]').getAttribute('content');

}
